import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./slider.script";
export function RuiSliderValue({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-slider__value", className),
    "data-ref": "value",
    "aria-hidden": "true",
    children
  });
}
function SliderTrack({
  disabled,
  min,
  max,
  label,
  variant
}) {
  const single = variant !== "range";
  const thumbLabel = label || "Value";
  return /* @__PURE__ */jsx("div", {
    class: "rui-slider__range",
    children: /* @__PURE__ */jsxs("div", {
      class: "rui-slider__range-track",
      "data-ref": "rangeTrack",
      children: [/* @__PURE__ */jsx("div", {
        class: "rui-slider__range-fill",
        "data-ref": "rangeFill"
      }), /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-slider__thumb",
        "data-ref": "singleThumb",
        "data-thumb": "value",
        role: "slider",
        tabindex: disabled || !single ? -1 : 0,
        "aria-label": thumbLabel,
        "aria-valuemin": min,
        "aria-valuemax": max,
        disabled: disabled || !single,
        hidden: !single
      }), /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-slider__thumb",
        "data-ref": "rangeMinThumb",
        "data-thumb": "min",
        role: "slider",
        tabindex: disabled || single ? -1 : 0,
        "aria-label": label ? `${label} minimum` : "Minimum value",
        "aria-valuemin": min,
        "aria-valuemax": max,
        disabled: disabled || single,
        hidden: single
      }), /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-slider__thumb",
        "data-ref": "rangeMaxThumb",
        "data-thumb": "max",
        role: "slider",
        tabindex: disabled || single ? -1 : 0,
        "aria-label": label ? `${label} maximum` : "Maximum value",
        "aria-valuemin": min,
        "aria-valuemax": max,
        disabled: disabled || single,
        hidden: single
      })]
    })
  });
}
export function RuiSlider({
  values,
  variant = "single",
  orientation = "horizontal",
  label,
  showValue = false,
  valueTitle = false,
  disabled,
  name,
  min,
  max,
  children,
  ...props
}) {
  const valueReadout = children ?? /* @__PURE__ */jsx(RuiSliderValue, {
    "data-default-value": true,
    hidden: !showValue
  });
  const hasVisibleReadout = Boolean(children) || showValue;
  return /* @__PURE__ */jsx("rui-slider", {
    ...props,
    variant,
    orientation,
    label,
    showValue,
    valueTitle,
    disabled,
    name,
    min,
    max,
    rangeMin: values?.[0],
    rangeMax: values?.[1],
    children: /* @__PURE__ */jsxs("div", {
      class: cx("rui-slider", variant === "range" ? "rui-slider--range" : "rui-slider--single", orientation === "vertical" && "rui-slider--vertical"),
      "data-ref": "root",
      children: [/* @__PURE__ */jsxs("div", {
        class: "rui-slider__header",
        "data-ref": "header",
        hidden: !label && !hasVisibleReadout,
        children: [/* @__PURE__ */jsx("span", {
          class: "rui-slider__label",
          "data-ref": "label",
          hidden: !label,
          children: label
        }), valueReadout]
      }), /* @__PURE__ */jsx(SliderTrack, {
        disabled,
        min,
        max,
        label,
        variant
      }), /* @__PURE__ */jsx("input", {
        type: "hidden",
        "data-ref": "input",
        name: name || void 0
      }), /* @__PURE__ */jsx("input", {
        type: "hidden",
        "data-ref": "maxInput"
      })]
    })
  });
}